export default "__VITE_ASSET__g$bhaRPf__"